import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-appendix-a',
  templateUrl: './appendix-a.component.html',
  standalone: false,
  styleUrl: './appendix-a.component.scss'
})
export class AppendixAComponent {
  solutionAreaCategories = [
    {
      category: 'Developer Technologies',
      items: ['.NET', 'C++', 'Developer Security', 'Developer Tools', 'DevOps', 'Java', 'Python', 'Web Development']
    },
    {
      category: 'Microsoft 365',
      items: ['Access', 'Clipchamp', 'Excel', 'Exchange', 'Loop', 'M365 Copilot', 'M365 Copilot Extensibility', 'Mesh',
        'Microsoft 365', 'Microsoft Graph', 'Microsoft Teams', 'Microsoft Viva', 'OneDrive', 'OneNote', 'Outlook',
        'Planner', 'PowerPoint', 'SharePoint', 'Visio', 'Word']
    },
    {
      category: 'Business Applications',
      items: ['AI ERP', 'Business Central', 'Copilot Studio', 'Customer Experience', 'Customer Service', 'Power Apps',
        'Power Automate', 'Power Pages']
    },
    {
      category: 'Data Platform',
      items: ['Analysis Services', 'Azure Arc (Arc SQL Server, Arc SQL MI)', 'Azure Cosmos DB',
        'Azure Database for MySQL', 'Azure Database for PostgreSQL',
        'Azure SQL (Database, Pools, Serverless, Hyperscale, Managed Instance, Virtual Machines)',
        'Data Integration', 'Database Development & DevOps', 'Fabric Analytics', 'Microsoft Fabric',
        'Microsoft Purview - Data Governance', 'OneLake', 'Paginated Operational Reports (RDL)', 'Power BI',
        'Real-Time Intelligence', 'SQL Server (on Windows, Linux, Containers)', 'SQL Server ML Services',
        'Tools & Connectivity']
    },
    {
      category: 'Microsoft Azure',
      items: ['Azure Application PaaS', 'Azure Compute Infrastructure', 'Azure HPC & AI Infrastructure',
        'Azure Hybrid & Migration', 'Azure Infrastructure as Code', 'Azure Innovation Hub',
        'Azure Integration PaaS', 'Azure Kubernetes and Open Source', 'Azure Networking',
        'Azure Operations & Management', 'Azure Solutions & Ecosystem', 'Azure Storage',
        'Azure Well-Architected & Resiliency', 'PowerShell']
    },
    {
      category: 'Internet of Things',
      items: ['Azure Edge Devices', 'Azure IoT Services & Development']
    },
    {
      category: 'Windows and Devices',
      items: ['Azure Virtual Desktop', 'Surface', 'Windows', 'Windows 365']
    },
    {
      category: 'Security',
      items: ['Cloud Security (Microsoft Defender for Cloud, Azure network security products, GitHub Advanced Security)',
        'Identity & Access', 'Microsoft Intune', 'Microsoft Purview', 'Microsoft Security Copilot',
        'SIEM & XDR (Microsoft Sentinel & Microsoft Defender XDR suite)']
    },
    {
      category: 'Cloud and Datacenter Management',
      items: ['Datacenter Management (Group Policy, System Center)', 'Enterprise and Platform Security',
        'High Availability', 'Hyper-V', 'Linux on Hyper-V', 'On-premises and Hybrid AKS, Container Management',
        'On-Premises Identity', 'On-Premises Networking', 'On-Premises Storage', 'Windows Server']
    },
    {
      category: 'Microsoft Foundry',
      items: ['Microsoft Foundry']
    },
    {
      category: 'Windows Development',
      items: ['Windows Design', 'Windows Development']
    }
  ];

  constructor(public dialogRef: MatDialogRef<AppendixAComponent>) { }

  close(): void {
    this.dialogRef.close();
  }
}
